import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Services from './components/Services';
import AIGovernance from './components/AIGovernance';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LegalPage from './components/LegalPage';

function HomePage() {
  return (
    <div className="min-h-screen bg-brand-dark">
      <Header />
      <main>
        <Hero />
        <Features />
        <About />
        <Services />
        <AIGovernance />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
        <Route path="/cookie-policy" element={<LegalPage type="cookies" />} />
        <Route path="/terms-of-service" element={<LegalPage type="terms" />} />
        <Route path="/acceptable-use-policy" element={<LegalPage type="acceptable-use" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;